import * as React from 'react';

import { ModalBase, ModalBaseProps } from './ModalBase.js';

export type ModalProps<T extends React.ElementType = 'div'> = ModalBaseProps<T>;

/**
 * Modal is a lower-level construct
 */
export const Modal = React.forwardRef(
  <T extends React.ElementType>(
    { children, ...restProps }: ModalBaseProps<T>,
    ref: React.ForwardedRef<React.ElementRef<T>>
  ) => {
    return (
      <ModalBase ref={ref} {...restProps}>
        {children}
      </ModalBase>
    );
  }
);

export default Modal;
